/** Concatenated receipt header text block built from the user's receipt form. */
export type ReceiptHeader = Readonly<string>;

/**
 * Builds the receipt header text from the commercial and fiscal info
 * entered by the user in step 6 of the wizard. Pieces are comma-separated.
 *
 * @param params - Raw values from the receipt form
 * @returns Frozen ReceiptHeader string
 */
export const createReceiptHeader = (params: {
  businessName: string;
  legalName: string;
  rfc: string;
  fiscalAddress: string;
}): ReceiptHeader => {
  const pieces = [
    'Información comercial:',
    `Nombre comercial: ${params.businessName.trim()}`,
    `Razón social: ${params.legalName.trim()}`,
    `RFC: ${params.rfc.trim().toUpperCase()}`,
    `Dirección fiscal: ${params.fiscalAddress.trim()}`,
  ];
  const header = pieces.join(', ');
  return header.slice(0, 255) as ReceiptHeader;
};
